module.exports = __webpack_public_path__ + "img/IMG_1563.4ed6b99d.jpg";